import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import ConfigApp from 'src/services/configApp';
import DossieColaborador from 'src/paginas/avaliacao-desempenho/DossieColaborador';
import ContentManager from 'src/componentes/content-manager';
import { ADDONS } from 'src/utils/constants';
import useAuth from 'src/hooks/useAuth';

import css from '../../utils/css';
import getInitials from '../../utils/getInitials';
import http from 'src/services/httpService';

const Avatar = ({
  label,
  size,
  labelSize,
  showLabel = true,
  border = 2,
  semEstilo = false,
  foto,
  showInitials = true,
  showTooltip,
  showDossie,
  intl,
  id = 'avatar',
  labelLinkCallback,
  semMargin = false,
  transparent,
  labelColor,
  shadow,
  bold,
  fontSize,
  subLabel,
  borderColor = '#FFFFFF',
  labelWidth = null,
  colaboradorId,
  ...rest
}) => {
  const { addons } = useAuth();

  const [possuiPermissaoDossie, setPossuiPermissaoDossie] = useState(false);

  const possuiAddonDossie =
    addons?.find((x) => x.id === ADDONS.DOSSIE_COLABORADOR && x.ativo) != null;

  const dossieEnabled =
    showDossie && possuiAddonDossie && possuiPermissaoDossie;

  const tratarUnidade = (valor) => {
    if (valor === undefined || valor === null) {
      return;
    }

    if (typeof valor === `string`) {
      if (valor.indexOf('%') !== -1) {
        return valor;
      } else if (valor.indexOf('px') !== -1) {
        return valor;
      } else if (valor.indexOf('em') !== -1) {
        return valor;
      }
    }

    return valor + 'px';
  };

  let classes = css`
    .main {
      display: flex;
      align-items: center;
    }

    .avatar {
      min-width: ${tratarUnidade(size) || 'auto'};
      min-height: ${tratarUnidade(size) || 'auto'};
      width: ${tratarUnidade(size) || 'auto'};
      height: ${tratarUnidade(size) || 'auto'};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: ${dossieEnabled ? 'pointer' : 'default'};
    }

    .imgPerfil {
      min-width: ${tratarUnidade(size) || 'auto'};
      min-height: ${tratarUnidade(size) || 'auto'};
      width: ${tratarUnidade(size) || 'auto'};
      height: ${tratarUnidade(size) || 'auto'};
      font-size: ${tratarUnidade(labelSize) || 'auto'};
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: ${dossieEnabled ? 'pointer' : 'default'};
    }

    .label {
      display: inline;
      margin-left: 10px;
      font-size: ${tratarUnidade(fontSize) || 'auto'};
    }
  `;

  const handleAvatarClick = () => {
    if (dossieEnabled)
      ContentManager.addContent(
        <DossieColaborador colaboradorId={colaboradorId} />
      );
  };

  const getPermissionDossie = () => {
    const response = http.get(
      'DossieColaborador/ObterPermissaoDossieColaborador'
    );

    return response;
  };

  useEffect(() => {
    if (showDossie && possuiAddonDossie) {
      setPossuiPermissaoDossie(getPermissionDossie());
    } else {
      setPossuiPermissaoDossie(false);
    }
  }, [showDossie, possuiAddonDossie]);

  return (
    <>
      <div
        id={id}
        data-tip={label}
        data-for={id}
        className={classes.main}
        onClick={handleAvatarClick}
        {...rest}
      >
        <div
          style={{
            ...(!semEstilo &&
              possuiPermissaoDossie && {
                padding: `${border}px`,
                background: 'linear-gradient(to right, #1D7789, #05F250)',
                borderRadius: '50%',
                display: 'inline-flex',
                overflow: 'hidden',
              }),
          }}
        >
          {foto && foto.id > 0 ? (
            <img
              alt=""
              src={`${ConfigApp.ApiUrl}/ArquivoSistema/DownloadImagem?guid=${foto.guid}`}
              className={classes.avatar}
              style={{
                borderRadius: '50%',
                display: 'block',
                boxShadow: shadow ? 'rgba(0, 0, 0, 0.35) 0px 5px 15px' : '',
                border: semEstilo
                  ? ''
                  : dossieEnabled
                  ? '2px solid white'
                  : `${border}px solid ${borderColor}`,
              }}
            />
          ) : (
            <span
              style={{
                border: semEstilo
                  ? ''
                  : dossieEnabled
                  ? '2px solid white'
                  : `${border}px solid ${borderColor}`,
                marginTop: semMargin ? 0 : 2,
                background: transparent ? 'transparent' : '#BCBCBC',
                color: labelColor ?? '#fff',
                fontWeight: bold ? 'bold' : '',
                boxShadow: shadow ? 'rgba(0, 0, 0, 0.35) 0px 5px 15px' : '',
                fontSize,
              }}
              className={classes.imgPerfil}
            >
              {label && (showInitials ? getInitials(label) : label)}
            </span>
          )}
        </div>
        {showLabel && label && (
          <div style={{ maxWidth: labelWidth ?? '' }}>
            <div className={'text-truncate ml-2'}>
              {!labelLinkCallback ? (
                label
              ) : (
                <a
                  className="font-weight-bold text-primary cursor-pointer"
                  onClick={labelLinkCallback}
                >
                  {label}
                </a>
              )}
            </div>
            {subLabel && (
              <div
                className={'text-truncate ml-2 font-weight-light text-muted'}
                style={{ fontSize: '0.75rem' }}
              >
                {<span>{subLabel}</span>}
              </div>
            )}
          </div>
        )}
      </div>
      {showTooltip && label && id && !dossieEnabled && (
        <ReactTooltip id={id} aria-haspopup="true" />
      )}
      {dossieEnabled && possuiAddonDossie && (
        <ReactTooltip id={id} place="bottom" aria-haspopup="true">
          {intl.formatMessage({ id: 'verDossieToolTip' })}
        </ReactTooltip>
      )}
    </>
  );
};

export default injectIntl(Avatar);
